<template>
    <div class="binding-page">
        <navBar title="激活绑定卡"  @onClickLeft="handleBack"/>
        <div class="main-box">
            <div class="handle-wrap">
                <div class="title">卡密绑定</div>
                <div class="login-wrap" v-if="!isLogin">
                    <!-- 未登录 -->
                    
                    <div class="form-box">
                        <div class="form-item">
                            <span class="icon icon-phone"></span>
                            <input type="text" maxlength="11" @blur="!onCheckPhone(formData.phone)" placeholder="请输入手机号" v-model="formData.phone">
                            <p class="error" v-show="!isPhoneError">请输入正确的手机号</p>
                        </div>
                        <div class="form-item">
                            <span class="icon icon-code"></span>
                            <input type="text" maxlength="6"  @blur="!onCheckCode(formData.code)" placeholder="请输入验证码" v-model="formData.code">
                            <div class="get-code" @click="handleCode">{{this.time == 60 ?'获取验证码': `${time >= 10 ? time: `0${time}`}s`}}</div>
                            <p class="error" v-show="!isCodeError">请输入6位数字验证码</p>
                        </div>
                    </div>
                    <div class="btn" :class="{disable: btnIsDisable}" @click="handleLogin">下一步</div>
                </div>
                <div class="bind-wrap" v-else>
                    <!-- 已登录 -->
                    <div class="form-box">
                        <div class="form-item">
                            <span class="icon icon-lock"></span>
                            <input type="number" maxlength="30" placeholder="请输入兑换码" v-model="formData.cardNum">
                        </div>
                        <div class="form-item">
                            <span class="icon icon-lock"></span>
                            <input type="text" maxlength="30" onkeyup="value=value.replace(/[\W]/g,'')" placeholder="请输入推荐方ID" v-model="formData.channelBranchNum">
                        </div>
                    </div>
                    <div class="btn" :class="{disable: btnIsDisable}" @click="handleBind">激活</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from "../../../api";
    import md5 from 'js-md5';
    import {Toast} from 'vant'
    import navBar from '../components/navBar.vue';

    const isPhone = /^1(?:3[0-9]|4[5-9]|5[0-9]|6[12456]|7[0-8]|8[0-9]|9[0-9])[0-9]{8}$/
    const isCode =/[0-9]{6}/;

    const cardType ={
        1: '/dream',
        2: '/flaunt'
    }
    export default {
        async beforeRouteEnter(to, from, next) {
            const isLogin = localStorage.getItem('token');
            
            if(isLogin) {
                const {success, data} = await api.entityCard.checkBindStatus();
                if(success) {
                    if(data) {
                        next({
                            path: cardType[data.id]
                        })
                        return;
                    }
                }
            }
            next(vm => {
                vm.isLogin = isLogin;
            });
        },
        components: {
            navBar,
        },
        data() {
            return {
                isLogin: false,
                branchUcode: '', // 机构UCode
                timer: null,
                isPhoneError: true,
                isCodeError: true,
                time: 60,
                formData: {
                    phone: '',
                    code: '',
                    cardNum: '',
                    channelBranchNum:''
                },
            }
        },
        
        destroyed () {
            this.timer = null;
        },
        created () {
            this.branchUcode = localStorage.getItem('branchUcode');
            this.branchId = localStorage.getItem('branchId');
        },
        computed: {
            btnIsDisable() {
                const {isLogin, formData: { phone, code, cardNum, channelBranchNum }} = this;
                return isLogin ? !cardNum || !channelBranchNum : !phone || !code;
            },
            is_login_current_branch() {
                let is_login_current_branch = this.$store.state.dynamic.frontendConfig.find((item) => item.key === 'is_login_current_branch')
                return is_login_current_branch ? is_login_current_branch.value == 'true' : false
            },
        },
        methods: {
            onCheckPhone(phone) {
                this.isPhoneError = isPhone.test(phone);
            },
            onCheckCode(code) {
                this.isCodeError = isCode.test(code)
            },
            onGetCode() {
                const {formData: {phone}} = this;
                if(this.isPhoneError) {
                    const data = { account: phone, type: 1 }
                    return this.$api.usercenter.getAuthCodeCommon({ data })
                }
                return Promise.reject(new Error('请输入正确的手机号'))
            },
            
            async handleCode() {
                this.onCheckPhone(this.formData.phone);
                if(!this.isPhoneError) { return false;}
                
                if(!this.codeLock) {
                    this.codeLock = true;
                    try {
                        const {success, data} = await this.onGetCode();
                        if(success && data) {
                            if(this.time == 60) {
                                this.timer = setInterval(()=>{
                                    this.time -= 1;
                                    if(this.time == 0) {
                                        clearInterval(this.timer);
                                        this.codeLock = false;
                                        this.time = 60;
                                    }  
                                },1000)
                            }
                        } else {
                            this.codeLock = false;
                        }
                    } catch (error) {
                        this.codeLock = false;
                    }
                }
            },

            getUserInfo() {
                return new Promise((resolve)=>{
                    this.$api.usercenter.getAccountUserInfo({}).then((res) => {
                        localStorage.setItem('WDuserInfo', JSON.stringify(res.data))
                        this.$store.commit('setUserInfo', res.data)
                        resolve()
                    })
                })
            },

            // 查询用户id
            findUserId() {
                return new Promise((resolve)=>{
                    this.$api.usercenter.findUser().then((res) => {
                        if (res.code == 0) {
                            let subUser = { id: res.data.id }
                            localStorage.setItem('subUserInfo', JSON.stringify(subUser))
                            resolve()
                        }
                    })
                })
            },

            onLogin(method,data) {
                return this.$api.usercenter[method]({ data })
            },

            async handleLogin() {
                if(this.btnIsDisable) return false;
                const {phone, code} = this.formData;
                if(!this.isPhoneError || !this.isCodeError) {
                    return false;
                }
                
                localStorage.removeItem('code')
                localStorage.removeItem('organ')
                localStorage.removeItem('actor')
                localStorage.removeItem('branch')
                localStorage.removeItem('channel')

                
                const data = {
                    account: phone,
                    authCode: code,
                }

                let method = 'postAccountLoginByAuthCode'; //验证码登录（没有账号直接注册到当前租户根机构）
                if(this.is_login_current_branch) {//验证码登录（没有账号直接注册到当前机构）
                    method = 'login2Branch'
                    data.branchUcode = this.branchUcode
                }
                this.$store.state.distributionId && (data.distributionId = this.$store.state.distributionId)
                const res = await this.onLogin(method, data)
                if (res.data) {
                    localStorage.setItem('token', res.data)

                    //分校信息接口，返回信息作用于checkSaveDetail接口请求头，影响返回值
                    let branchRes = []
                    try {
                        branchRes = await this.$api.account.getFindUserBranchList({});
                    } catch (error) {
                        if (error) {
                            return localStorage.removeItem('token')
                        }
                    }
                    if (branchRes.data && branchRes.data.length) {

                        let currentBranch = branchRes.data[0]

                        if (this.is_login_current_branch) {
                            // 登录域名指定的子机构
                            currentBranch = branchRes.data.find((item) => {
                                let branch = md5(this.branchId + item.token).toUpperCase()
                                return item.branch === branch
                            })
                            
                            if(!currentBranch){
                                this.$notify({
                                    type: 'warning',
                                    message: '暂未加入到当前机构！',
                                })
                                return
                            }
                        }

                        localStorage.setItem('code', currentBranch.code);
                        localStorage.setItem('organ', currentBranch.organ);
                        localStorage.setItem('actor', currentBranch.actor);
                        localStorage.setItem('branch', currentBranch.branch);

                        if(currentBranch.channel) {
                            localStorage.setItem(
                                'channel',
                                currentBranch.channel
                            )
                            this.$sensors.login(currentBranch.code)
                        }
                    } else {
                        return localStorage.removeItem('token')
					}

                    // 获取用户信息
                    await this.getUserInfo();
                    // 获取用户id
                    await this.findUserId();

                    const {success, data} = await this.$api.entityCard.checkBindStatus();
                    if(success) {
                        if(data) {
                            this.$router.push({
                                path: cardType[data.id]
                            })
                            return;
                        }
                    }
                    this.isLogin = true;
                }
            },

            onBind() {
                return this.$api.entityCard.bind({
                    code: this.formData.cardNum,
                    channelBranchNum:this.formData.channelBranchNum
                })
            },

            async handleBind() {
                if(this.btnIsDisable) return false;
                if(!this.lock) {
                    this.lock = true;
                    try {
                        const {success, data, message} = await this.onBind();
                        if(success && data) {
                            this.$router.push(cardType[data.id])
                        } else {
                            Toast(message)
                        }
                        this.lock = false
                    } catch (error) {
                        this.lock = false
                    }
                    
                }
            },
            handleBack() {
                this.$router.go(-1);
            }
        },
    }
</script>

<style lang="less" scoped>
    .binding-page {
        min-height: 100vh;
        .main-box {
            padding-top: 180px;
            background: url('../asset/images/bindBg.png') no-repeat top center /100% 310px;
        }
        .handle-wrap {
            margin: 0px 30px;
            padding: 40px 20px 73px;
            box-shadow: 0px 10px 31px 0px rgba(0,0,0,0.1);
            border-radius: 15px;
            background: #FFFFFF;
            box-sizing: border-box;
            min-height: 600px;
            display: flex;
            flex-direction: column;
            .title {
                text-align: center;
                font-size: 32px;
                font-weight: 500;
                color: #333;
                margin-bottom: 50px;
            }
            .login-wrap, .bind-wrap {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
            }
            .form-box {
                margin-bottom: 86px;
                flex: 1;
            }
            .form-item {
                display: flex;
                align-items: center;
                margin-bottom: 40px;
                position: relative;
                .error {
                    position: absolute;
                    left: 46px;
                    top: 98px;
                    color: #FF4E33;
                    font-size: 26px;

                }
                &:last-child {
                    margin-bottom: 0;
                }
                .icon {
                    width: 44px;
                    height: 44px;
                    display: block;
                    position: absolute;
                    left: 40px;
                    top: 50%;
                    transform: translateY(-50%);
                    background-size: 100% 100%;
                    &.icon-phone {
                        background-image: url('../asset/images/icon_phone.png');
                    }
                    &.icon-code {
                        background-image: url('../asset/images/icon_code.png');
                    }
                    &.icon-lock {
                        background-image: url('../asset/images/icon_lock.png');
                    }
                }
                input {
                    flex: 1;
                    height: 96px;
                    border: 0px;
                    border-radius: 4px;
                    padding: 0 20px 0 94px;
                    box-sizing: border-box;
                    background-color: #f5f5f5;
                    border-radius: 55px;
                    box-sizing: border-box;
                    min-width: 100px;
                    font-size: 28px;
                    font-weight: 400;
                    color: #333333;
                    line-height: 40px;
                    &:focus {
                        background-color: #f5f5f5;
                        box-shadow: 0 0 0 26.66667rem #f5f5f5 inset;
                    }
                    &::placeholder {
                        font-size: 28px;
                        font-weight: 400;
                        color: #C1C1C1;
                        line-height: 40px;
                    }
                }
                .get-code {
                    height: 96px;
                    line-height: 96px;
                    width: 220px;
                    margin-left: 30px;
                    background-color: #fff;
                    text-align: center;
                    border-radius: 55px;
                    border: 2px solid #E8E8E8;
                    font-size: 28px;
                    color: #333;
                }
            }
            .btn {
                text-align: center;
                height: 80px;
                line-height: 80px;
                background: linear-gradient(90deg, #C94DF9 0%, #7E4CF8 100%);
                color: #fff;
                font-size: 30px;
                border-radius: 50px;
                &.disable {
                    opacity: 0.6;

                }
            }
        }
    }
</style>